import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Control } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: Control }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerControls,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
